
<template>
  <div style="width: 600px;margin: 30px;">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="160px"
    >
      <el-form-item
        label="企业名称"
        prop="name"
      >
        <el-input
          v-model="form.name"
          placeholder="请输入企业名称"
          maxlength="255"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="企业税号"
        prop="taxplayerCode"
      >
        <el-input
          v-model="form.taxplayerCode"
          placeholder="请输入企业税号"
          maxlength="255"
          clearable
        />
      </el-form-item>
      <el-form-item label="企业类别">
        <el-select
          v-model="form.companyType"
          placeholder="请选择企业类别"
        >
          <el-option
            label="自营平台"
            :value="2"
          />
          <el-option
            label="合作商户"
            :value="3"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="运行范围"
        prop="operatingRangeType"
      >
        <el-select
          v-model="form.operatingRangeType"
          placeholder="请选择运营范围"
        >
          <el-option
            label="快递"
            :value="1"
          />
          <el-option
            label="速运"
            :value="2"
          />
          <el-option
            label="货运代理"
            :value="3"
          />
          <el-option
            label="普通货运"
            :value="4"
          />
          <el-option
            label="专线运输"
            :value="5"
          />
          <el-option
            label="其他"
            :value="6"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="联系人"
        prop="contact"
      >
        <el-input
          v-model="form.contact"
          placeholder="请输入联系人"
          maxlength="128"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="联系人电话"
        prop="tel"
      >
        <el-input
          v-model="form.tel"
          placeholder="请输入联系人电话"
          maxlength="11"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="紧急联系人"
        prop="emergencyContact"
      >
        <el-input
          v-model="form.emergencyContact"
          placeholder="请输入紧急联系人"
          maxlength="128"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="紧急联系人电话"
        prop="emergencyTel"
      >
        <el-input
          v-model="form.emergencyTel"
          placeholder="请输入紧急联系人电话"
          maxlength="11"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="购方客户名称"
        prop="buyerName"
      >
        <el-input
          v-model="form.buyerName"
          placeholder="请输入购方客户名称"
          maxlength="128"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="购方税号"
        prop="buyerTaxpayerCode"
      >
        <el-input
          v-model="form.buyerTaxpayerCode"
          placeholder="请输入购方税号"
          maxlength="255"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="购方单位地址"
        prop="buyerAddr"
      >
        <el-input
          v-model="form.buyerAddr"
          placeholder="请输入购方单位地址"
          maxlength="255"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="购方电话"
        prop="buyerTel"
      >
        <el-input
          v-model="form.buyerTel"
          placeholder="请输入购方电话"
          maxlength="20"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="购方开户行"
        prop="buyerBank"
      >
        <el-input
          v-model="form.buyerBank"
          placeholder="请输入购方开户行"
          maxlength="255"
          clearable
        />
      </el-form-item>
      <el-form-item
        label="购方银行账号"
        prop="buyerBankAccount"
      >
        <el-input
          v-model="form.buyerBankAccount"
          placeholder="请输入购方银行账号"
          maxlength="255"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-button
          v-if="getLimit('companyInfo_search_button')"
          type="primary"
          @click="funcSubmit"
        >
          确 定
        </el-button>
        <el-button
          v-if="getLimit('companyInfo_register_button') && buttonShow"
          type="primary"
          @click="companyRegister"
        >
          注册
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import request from '@/utils/request'
import { isCellphone } from '@/utils/validate4Form'
export default {
    name: 'CompanyInfo',
    data() {
        return {
            buttonShow: true,
            form: {
                name: '',
                taxplayerCode: '',
                companyType: '',
                operatingRangeType: '',
                contact: '',
                tel: '',
                emergencyContact: '',
                emergencyTel: '',
                buyerName: '',
                buyerTaxpayerCode: '',
                buyerAddr: '',
                buyerTel: '',
                buyerBank: '',
                buyerBankAccount: '',
                companyNum: '',
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请输入企业名称',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 255,
                        message: '长度在 1 到 255 个字符'
                    },
                ],
                taxplayerCode: [
                    {
                        required: true,
                        message: '请输入企业税号',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 255,
                        message: '长度在 1 到 255 个字符'
                    },
                ],
                companyType: [
                    {
                        required: true,
                        message: '请选择所属类别',
                        trigger: 'blur',
                    },
                ],
                operatingRangeType: [
                    {
                        required: true,
                        message: '请选择运营范围',
                        trigger: 'blur',
                    },
                ],
                contact: [
                    {
                        required: true,
                        message: '请输入联系人',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 128,
                        message: '长度在 1 到 128 个字符'
                    },
                ],
                tel: [
                    {
                        required: true,
                        message: '请输入联系人电话',
                        trigger: 'blur',
                    },
                    {validator: isCellphone}
                ],
                emergencyContact: [
                    {
                        required: true,
                        message: '请输入紧急联系人',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 128,
                        message: '长度在 1 到 128 个字符'
                    },
                ],
                emergencyTel: [
                    {
                        required: true,
                        message: '请输入紧急联系人电话',
                        trigger: 'blur',
                    },
                    {validator: isCellphone}
                ],
                buyerName: [
                    {
                        required: true,
                        message: '请输入购方客户名称',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 128,
                        message: '长度在 1 到 128 个字符'
                    },
                ],
                buyerTaxpayerCode: [
                    {
                        required: true,
                        message: '请输入购方税号',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 255,
                        message: '长度在 1 到 255 个字符'
                    },
                ],
                buyerAddr: [
                    {
                        required: true,
                        message: '请输入购方单位地址',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 255,
                        message: '长度在 1 到 255 个字符'
                    },
                ],
                buyerTel: [
                    {
                        required: true,
                        message: '请输入购方电话',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 20,
                        message: '长度在 1 到 20 个字符'
                    },
                ],
                buyerBank: [
                    {
                        required: true,
                        message: '请输入购方开户行',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 255,
                        message: '长度在 1 到 255 个字符'
                    },
                ],
                buyerBankAccount: [
                    {
                        required: true,
                        message: '请输入购方银行账号',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 255,
                        message: '长度在 1 到 255 个字符'
                    },
                ],
            },
        }
    },
    created() {
        this.getInfo()
    },
    methods: {
        getInfo() {
            return request({
                url: '/ntocc-tms-api/etc/getCompanyInfo',
                method: 'get',
            }).then((reponse) => {
                if (reponse.data) {
                    this.form = reponse.data
                    if (reponse.data.companyNum) {
                        this.buttonShow = false
                    }
                }
            })
        },
        companyRegister() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    const rLoading = this.openLoading()
                    request({
                        url: '/ntocc-tms-api/etc/companyRegister',
                        method: 'post',
                    }).then((response) => {
                        this.getInfo()
                        rLoading.close()
                        this.$message({
                            message: response.msg,
                            type: 'success',
                        })
                    })
                } else {
                    return false
                }
            })
        },
        funcSubmit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    const data = this.form
                    const rLoading = this.openLoading()
                    request({
                        url: '/ntocc-tms-api/etc/saveOrUpdateCompanyInfo',
                        method: 'post',
                        params: data,
                    }).then((response) => {
                        this.getInfo()
                        rLoading.close()
                        this.$message({
                            message: response.msg,
                            type: 'success',
                        })
                    })
                } else {
                    return false
                }
            })
        },
    },
}
</script>

<style scoped>
</style>
